/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Filter_LabelInputs */

const en_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const fr_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtre`)
};

const de_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter`)
};

const it_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro`)
};

const ru_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фильтр`)
};

const es_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar`)
};

const zh_cn2_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选`)
};

const ja_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルター`)
};

const hi_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़िल्टर`)
};

const pt_pt2_voice_manager_filter_label = /** @type {(inputs: Voice_Manager_Filter_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtro`)
};

/**
* | output |
* | --- |
* | "Filter" |
*
* @param {Voice_Manager_Filter_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_filter_label = /** @type {((inputs?: Voice_Manager_Filter_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Filter_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_filter_label(inputs)
	if (locale === "de") return de_voice_manager_filter_label(inputs)
	if (locale === "it") return it_voice_manager_filter_label(inputs)
	if (locale === "ru") return ru_voice_manager_filter_label(inputs)
	if (locale === "es") return es_voice_manager_filter_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_filter_label(inputs)
	if (locale === "ja") return ja_voice_manager_filter_label(inputs)
	if (locale === "hi") return hi_voice_manager_filter_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_filter_label(inputs)
	return en_voice_manager_filter_label(inputs)
});